import React, { useState, useEffect } from 'react';
import { HelpCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const response = await axios.get(`${API}/faqs`);
      setFaqs(response.data);
    } catch (error) {
      console.error('Error fetching FAQs:', error);
    }
  };

  return (
    <div className="min-h-screen bg-white pt-24">
      {/* Hero Section */}
      <section className="relative py-20 px-6">
        <div className="absolute inset-0 bg-gradient-to-br from-orange-50/30 via-white to-amber-50/20"></div>
        
        <div className="relative max-w-4xl mx-auto text-center space-y-6">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-[#FF6B35] to-[#F7931E] mb-4">
            <HelpCircle className="h-10 w-10 text-white" />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#FF6B35] to-[#F7931E]">
            Frequently Asked Questions
          </h1>
          <p className="text-lg text-[#5B6B7F] max-w-2xl mx-auto">
            Find detailed answers to common questions about our OTC exchange services, onboarding process, and compliance requirements.
          </p>
        </div>
      </section>

      {/* FAQ Content Section */}
      <section className="py-12 px-6 bg-gradient-to-b from-[#FAFBFC] to-white">
        <div className="max-w-4xl mx-auto">
          {faqs.length > 0 ? (
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq) => (
                <AccordionItem 
                  key={faq._id || faq.id} 
                  value={faq._id || faq.id}
                  className="bg-white border-2 border-gray-200 rounded-xl px-6 hover:border-[#FF6B35]/50 transition-all shadow-sm hover:shadow-lg"
                >
                  <AccordionTrigger className="text-left text-lg font-semibold text-[#1E3A5F] hover:text-[#FF6B35] transition-colors py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-base text-[#5B6B7F] leading-relaxed pb-5 whitespace-pre-line">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          ) : (
            <div className="text-center py-12">
              <p className="text-[#5B6B7F]">Loading FAQs...</p>
            </div>
          )}
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="py-12 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 border-2 border-[#FF6B35]/20">
            <h3 className="text-2xl font-bold text-[#1E3A5F] mb-4 text-center">Still have questions?</h3>
            <p className="text-[#5B6B7F] leading-relaxed mb-6 text-center">
              Our team is here to help. Contact us for more information about our services, onboarding process, or compliance requirements.
            </p>
            <div className="text-center">
              <a 
                href="/contact" 
                className="inline-block bg-gradient-to-r from-[#FF6B35] to-[#F7931E] hover:from-[#F7931E] hover:to-[#FF6B35] text-white px-8 py-3 rounded-xl font-semibold transition-all duration-300 hover:scale-105 shadow-lg"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;
